import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    GetChangeOrderCostsResult,
    OpportunityChangeOrderEstimateClient,
    OpportunityChangeOrderEstimateViewPaginatedResultDto,
    SearchOpportunityEstimateParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityChangeOrderEstimateService {
    constructor(private readonly client: OpportunityChangeOrderEstimateClient) {}

    async costsOverview(opportunityId: number): Promise<GetChangeOrderCostsResult> {
        return await lastValueFrom(this.client.opportunityChangeOrderEstimateGetCostsOverview(opportunityId));
    }

    async searchChangeOrdersByOpportunity(
        body: SearchOpportunityEstimateParameters
    ): Promise<OpportunityChangeOrderEstimateViewPaginatedResultDto> {
        return await lastValueFrom(this.client.opportunityChangeOrderEstimateSearchChangeOrdersByOpportunity(body));
    }
}
